import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";

/* Full-viewport daily-usage lock — port of shell.js Shell.lockOut. Shows a live
 * countdown to UTC midnight and a sign-out button; reloads when it hits zero. */
export default function UsageLock({ resetEpoch }) {
  const { logout } = useAuth();
  const target =
    (resetEpoch || (Math.floor(Date.now() / 1000 / 86400) + 1) * 86400) * 1000;
  const [label, setLabel] = useState("—");

  useEffect(() => {
    const tick = () => {
      const ms = Math.max(0, target - Date.now());
      const s = Math.floor(ms / 1000);
      const h = String(Math.floor(s / 3600)).padStart(2, "0");
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
      const ss = String(s % 60).padStart(2, "0");
      setLabel(`${h}:${m}:${ss}`);
      if (ms <= 0) window.location.reload();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  return (
    <div className="usage-lock">
      <div className="usage-lock-card">
        <div className="usage-lock-icon">⏳</div>
        <h2>Daily usage limit reached</h2>
        <p>
          Your account has used today's allowed time on the app. Access unlocks
          automatically at <b>00:00 UTC</b>.
        </p>
        <p className="usage-lock-count">
          Unlocks in <b>{label}</b>
        </p>
        <button className="btn" onClick={logout}>
          Sign out
        </button>
      </div>
    </div>
  );
}
